module.exports = __webpack_public_path__ + "static/media/dog.4cf3e9bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/dog.png
// module id = 153
// module chunks = 0